/* eslint-disable react/require-default-props */
import React from "react";

import { roundedPolygonPath, Pt } from "../../data/svgPaths";

const VIEW_H = 400;
const CX = 300;
const CY = 190;
const SIDE = 170;
// Match OperationsStack's TILE_HALF_W exactly so the cube's bounding box is
// identical to the stack's. A true isometric projection would give
// HALF_W = SIDE * cos(30deg) ≈ 147, leaving the cube ~6px narrower than the
// stack — which read as a size jump on the flip.
const HALF_W = 150;
const CORNER_R = 16;

const point = (dx: number, dy: number): Pt => [CX + dx, CY + dy];

const TOP_FACE: Pt[] = [
  point(0, -SIDE),
  point(HALF_W, -SIDE / 2),
  point(0, 0),
  point(-HALF_W, -SIDE / 2),
];
const LEFT_FACE: Pt[] = [
  point(-HALF_W, -SIDE / 2),
  point(0, 0),
  point(0, SIDE),
  point(-HALF_W, SIDE / 2),
];
const RIGHT_FACE: Pt[] = [
  point(HALF_W, -SIDE / 2),
  point(0, 0),
  point(0, SIDE),
  point(HALF_W, SIDE / 2),
];

interface IsometricCubeProps {
  viewBox?: string;
}

export default function IsometricCube({
  viewBox = `-100 0 800 ${VIEW_H}`,
}: IsometricCubeProps) {
  return (
    <svg
      viewBox={viewBox}
      aria-hidden="true"
      className="h-full w-full text-slate-400 dark:text-slate-500"
    >
      <path
        data-face="top"
        d={roundedPolygonPath(TOP_FACE, CORNER_R)}
        fill="white"
        fillOpacity={0.04}
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
      <path
        data-face="left"
        d={roundedPolygonPath(LEFT_FACE, CORNER_R)}
        fill="white"
        fillOpacity={0.02}
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
      <path
        data-face="right"
        d={roundedPolygonPath(RIGHT_FACE, CORNER_R)}
        fill="white"
        fillOpacity={0.06}
        stroke="currentColor"
        strokeWidth={1.25}
        strokeLinejoin="round"
      />
    </svg>
  );
}
